import script from "./select-file.vue?vue&type=script&lang=ts&setup=true"
export * from "./select-file.vue?vue&type=script&lang=ts&setup=true"

import "./select-file.vue?vue&type=style&index=0&id=a323ee34&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a323ee34"]])

export default __exports__